class CartCounter extends HTMLElement {
    constructor() {
        super();
        this.productId = this.getAttribute("data-product-id");
    }

    connectedCallback() {
        if (!this.productId) return;

        // Mostrar el número correcto en el widget
        this.showCartCount();
    }

    showCartCount() {
        const cookieData = this.getCookie(`cart_count_${this.productId}`);

        if (cookieData) {
            const { count, timestamp } = JSON.parse(cookieData);
            const now = Date.now();

            console.log('---------timestamot', count, timestamp);

            // Si la cookie sigue vigente (menos de 30 min), mostramos el mismo número
            if (now - timestamp < 30 * 60 * 1000) {
                this.querySelector('.added-counter-quantity').innerText = `${count}`;
                return;
            }

            // Si ha pasado más de 1 hora, generamos una pequeña fluctuación
            const updatedCount = this.applySmallVariation(count);
            this.setCartCount(updatedCount);
        } else {
            // Si no hay cookie, generamos un número aleatorio inicial
            const initialCount = this.getRandomCount();
            this.setCartCount(initialCount);
        }
    }

    getRandomCount() {
        const min = 5;
        const max = 12;
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    applySmallVariation(currentCount) {
        const variation = Math.floor(Math.random() * 5) - 2; // -2 a +2
        return Math.max(5, Math.min(12, currentCount + variation)); // Asegura que esté en rango
    }

    setCartCount(count) {
        const data = JSON.stringify({ count, timestamp: Date.now() });
        this.setCookie(`cart_count_${this.productId}`, data, 1);
        this.querySelector('.added-counter-quantity').innerText = `${count}`;
    }

    // Función para establecer cookies
    setCookie(name, value, hours) {
        let expires = "";
        if (hours) {
            let date = new Date();
            date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = `${name}=${value}; path=/; Secure; SameSite=Lax${expires}`;
    }

    // Función para leer cookies
    getCookie(name) {
        let nameEQ = `${name}=`;
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
        }
        return null;
    }
}

// Registrar el Web Component
customElements.define("cart-counter", CartCounter);